import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, color, onClick }) => {
  const getColorClasses = (color) => {
    switch (color) {
      case 'blue':
        return 'bg-[#2D869C]/10 text-[#2D869C] border-[#2D869C]/20';
      case 'green':
        return 'bg-green-50 text-green-600 border-green-200';
      case 'orange':
        return 'bg-orange-50 text-orange-600 border-orange-200';
      case 'red':
        return 'bg-red-50 text-red-600 border-red-200';
      case 'purple':
        return 'bg-purple-50 text-purple-600 border-purple-200';
      default:
        return 'bg-gray-50 text-gray-600 border-gray-200';
    }
  };

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-green-600';
      case 'negative':
        return 'text-red-600';
      default:
        return 'text-gray-500';
    }
  };

  return (
    <div 
      className={`bg-white rounded-xl border-2 border-gray-200 shadow-sm p-6 transition-all cursor-pointer hover:shadow-md hover:border-[#2D869C]/50 ${
        onClick ? '' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-semibold text-gray-600 mb-2">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mb-1">{value}</p>
          {change && (
            <div className="flex items-center mt-2">
              <Icon 
                name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
                size={16} 
                className={getChangeColor(changeType)}
              />
              <span className={`text-sm font-semibold ml-1 ${getChangeColor(changeType)}`}>
                {change}
              </span>
            </div>
          )}
        </div>
        <div className={`p-4 rounded-xl border-2 ${getColorClasses(color)}`}>
          <Icon name={icon} size={28} />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;